import React, { useState } from 'react';

const REPORT_SETTINGS_SUFFIX = 'report-settings'; // Base key may conflict with withPersistentSettings, so use a suffix

function writeLocalState(key, string) {
  return localStorage.setItem(key, string);
}

function saveLocalSettings(WrappedComponent, storageKey, props) {
  const prevState = JSON.parse(localStorage.getItem(storageKey)) || {};
  const [localState, updateLocalState] = useState(prevState);
  function handleNewReportSettings(reportSettings) {
    updateLocalState(reportSettings);
    writeLocalState(storageKey, JSON.stringify(reportSettings));
  }

  return (
    <WrappedComponent
      {...props}
      {...localState}
      saveReportSettings={handleNewReportSettings}
    />
  );
}

export default function saveLocalSettingsWrapper(WrappedComponent, componentBaseStorageKey) {
  const saveStorageKey = `${componentBaseStorageKey}-${REPORT_SETTINGS_SUFFIX}`;
  return (props) => saveLocalSettings(WrappedComponent, saveStorageKey, props);
}
